/* Dora Marquee JS Loop
 * Gestisce uno scroll infinito fluido senza sovrapposizioni.
 * Usa la variabile CSS --dmq-speed (durata in secondi di un ciclo) e duplica il contenuto.
 */
(function(){
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(prefersReduced) return; // non animare per accessibilità

  const sections = document.querySelectorAll('.dmq-section');
  sections.forEach(initMarquee);

  function initMarquee(section){
    const track = section.querySelector('[data-marquee-track]');
    if(!track) return;

    // Evita doppia inizializzazione
    if(track.__dmqInitialized) return; track.__dmqInitialized = true;

    // Contenuto base (ciclo) prima di duplicazioni
    const cycleChildren = Array.from(track.children).map(node => node.cloneNode(true));
    const cycleFragment = document.createDocumentFragment();
    cycleChildren.forEach(n => cycleFragment.appendChild(n));

    // Misura larghezza iniziale
    const baseWidth = measureWidth(track);

    // Duplica fino a coprire almeno 2.5x viewport della rail per garantire buffer
    const rail = section.querySelector('.dmq-rail') || track.parentElement;
    const neededWidth = (rail.getBoundingClientRect().width || window.innerWidth) * 2.5;
    while(track.scrollWidth < neededWidth){
      track.appendChild(cycleFragment.cloneNode(true));
    }

    let cycleWidth = baseWidth; // larghezza di un ciclo (originale)
    // Calcola velocità in px/sec: completare un ciclo = cycleWidth px in speedSeconds
    const speedVar = getComputedStyle(section).getPropertyValue('--dmq-speed').trim();
    const speedSeconds = parseFloat(speedVar.replace('s','')) || 32;
    const pxPerSecond = cycleWidth / speedSeconds;

    let offset = 0; // corrente translateX
    let lastTs = performance.now();
    let paused = false;

    section.addEventListener('mouseenter', () => paused = true);
    section.addEventListener('mouseleave', () => paused = false);

    function frame(now){
      const dt = (now - lastTs) / 1000; lastTs = now;
      if(!paused){
        offset -= pxPerSecond * dt;
        // quando superato un ciclo, riporta modulo cicloWidth
        if(offset <= -cycleWidth){
          offset += cycleWidth; // conserva il residuo per ultra fluidità
        }
        track.style.transform = `translateX(${offset}px)`;
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    // Resize debounce: ricalcola larghezze e velocità
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(recalculate, 180);
    });

    function recalculate(){
      // Reset duplicazioni e ricostruisci
      const originals = Array.from(track.children).slice(0, cycleChildren.length);
      track.innerHTML = '';
      cycleChildren.forEach(n => track.appendChild(n.cloneNode(true)));
      const newBaseWidth = measureWidth(track);
      // Duplica come prima
      while(track.scrollWidth < (rail.getBoundingClientRect().width || window.innerWidth) * 2.5){
        cycleChildren.forEach(n => track.appendChild(n.cloneNode(true)));
      }
      cycleWidth = newBaseWidth;
      offset = 0; // riparte pulito
    }
  }

  function measureWidth(el){
    // Forza reflow e ritorna scrollWidth che include inline-flex children
    return el.scrollWidth;
  }
})();
